import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DatabaseSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DatabaseSVG;
